<template>
    <div class="progress">
      <div
        class="progress-bar p-1 border border-secondary"
        :style="{ width: progressPercentage + '%', backgroundColor: barColor, color: textColor }"
        role="progressbar"
        :aria-valuenow="progress"
        :aria-valuemin="0"
        :aria-valuemax="total"
      >
        {{ progress }} / {{ total }}
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'ProgressStatus',
    props: {
      total: {
        type: String,
        default: 10,
      },
      progress: {
        type: String,
        default: 0,
      },
      barColor: {
        type: String,
        required: false,
        default: 'greenyellow', 
      },
      textColor: {
        type: String,
        required: false,
        default: 'black', 
      },
    },
    computed: {
      progressPercentage() {
        return Math.min((this.progress / this.total) * 100, 100);
      },
    },
  };
  </script>
  
  <style scoped>
  .progress {
    display: flex;
    height: 25px; 
    border: 2px solid greenyellow;
    color:black;
    background: white;    
  }
  </style>
  